import { render, staticRenderFns } from "./ClimbingStyleIcon.vue?vue&type=template&id=dcc26994"
import script from "./ClimbingStyleIcon.vue?vue&type=script&lang=js"
export * from "./ClimbingStyleIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports